module.exports = __webpack_public_path__ + "img/united-arab-emirates-flag.1ed96678.svg";